import './items';
import { ItemDefinition } from './items/Item';
import { BACKGROUND, LAYOUT_LIST, ROOT, TEXT } from './items/itemIds';
import { Translator } from './Translator';
import { Cards1 } from './translators/Cards1';
import { Cards2 } from './translators/Cards2';
import { Cards3 } from './translators/Cards3';
import { Cards4 } from './translators/cards4';
import { Cards5 } from './translators/cards5';
import { Cards6 } from './translators/Cards6';
import { Cards61 } from './translators/Cards61';
import { Cards7 } from './translators/Cards7';
import { Cards8 } from './translators/Cards8';
import { Quiz30 } from './translators/Quiz30';
import { Cards10 } from './translators/Cards10';
import { Images1 } from './translators/Images1';
import { Images2 } from './translators/Images2';
import { Images2BackgroundColor } from './translators/Images2BackgroundColor';
import { Images3 } from './translators/Images3';
import { Images6 } from './translators/Images6';
import { Images7 } from './translators/Images7';
import { Images9 } from './translators/Images9';
import { Interactive11 } from './translators/Interactive11';
import { Interactive12 } from './translators/Interactive12';
import { Interactive13 } from './translators/Interactive13';
import { Interactive14 } from './translators/Interactive14';
import { Interactive2 } from './translators/Interactive2';
import { Interactive23 } from './translators/Interactive23';
import { Interactive3 } from './translators/Interactive3';
import { Interactive30 } from './translators/Interactive30';
import { Interactive31 } from './translators/Interactive31';
import { Interactive32 } from './translators/Interactive32';
import { Interactive4 } from './translators/Interactive4';
import { Interactive7 } from './translators/Interactive7';
import { Interactive8 } from './translators/Interactive8';
import { Interactive9 } from './translators/Interactive9';
import { Interactive1 } from './translators/Interactive1';
import { InteractivePDF } from './translators/InteractivePDF';
import { List1 } from './translators/List1';
import { List2 } from './translators/List2';
import { List3 } from './translators/List3';
import { Multimedia1 } from './translators/Multimedia1';
import { Multimedia2 } from './translators/Multimedia2';
import { Multimedia4 } from './translators/Multimedia4';
import { Multimedia4_Quiz } from './translators/Multimedia4_Quiz';
import { Multimedia8 } from './translators/Multimedia8';
import { Quiz10 } from './translators/Quiz10';
import { Quiz11 } from './translators/Quiz11';
import { Quiz12 } from './translators/Quiz12';
import { Quiz13 } from './translators/Quiz13';
import { Quiz13Steps } from './translators/Quiz13Steps';
import { Quiz14 } from './translators/Quiz14';
import { Quiz2 } from './translators/Quiz2';
import { Quiz3 } from './translators/Quiz3';
import { Quiz4 } from './translators/Quiz4';
import { Quiz5 } from './translators/Quiz5';
import { Quiz8 } from './translators/Quiz8';
import { Quiz9 } from './translators/Quiz9';
import { Quote3 } from './translators/Quote3';
import { Quote5 } from './translators/Quote5';
import { Quote7 } from './translators/Quote7';
import { SocialMedia1 } from './translators/SocialMedia1';
import { SocialMedia2 } from './translators/SocialMedia2';
import { SocialMedia10 } from './translators/SocialMedia10';
import { SocialMedia12 } from './translators/SocialMedia12';
import { SocialMedia13 } from './translators/SocialMedia13';
import { SocialMedia14 } from './translators/SocialMedia14';
import { SocialMedia3 } from './translators/SocialMedia3';
import { SocialMedia4 } from './translators/SocialMedia4';
import { SocialMedia5 } from './translators/SocialMedia5';
import { SocialMedia5iPad } from './translators/SocialMedia5_iPad';
import { SocialMedia6 } from './translators/SocialMedia6';
import { SocialMedia6iPad } from './translators/SocialMedia6_iPad';
import { SocialMedia8 } from './translators/SocialMedia8';
import { SocialMedia9 } from './translators/SocialMedia9';
import { Statement2 } from './translators/Statement2';
import { Statement3 } from './translators/Statement3';
import { Statement5 } from './translators/Statement5';
import { Statement6 } from './translators/Statement6';
import { Text2 } from './translators/Text2';
import { Text4 } from './translators/Text4';
import { Text5 } from './translators/Text5';
import { ChartPie } from './translators/ChartPie';
import { ChartDoughnut } from './translators/ChartDoughnut';
import { ChartPolar } from './translators/ChartPolar';
import { ChartBar } from './translators/ChartBar';
import { ChartLine } from './translators/ChartLine';
import { QuizInsta } from './translators/QuizInsta';
import { QuizInstaSurvey } from './translators/QuizInstaSurvey';
import { SocialMediaPushNotifications } from './translators/SocialMediaPushNotifications';
import { QuizPhoneNotification } from './translators/QuizPhoneNotifications';
import { DragNDrop } from './translators/DragNDrop';
import { Simulation } from './translators/Simulation';

const UnknownTemplate: ItemDefinition<typeof ROOT, void> = {
  id: '1',
  type: ROOT,
  values: void {},
  items: [
    {
      id: '2',
      type: BACKGROUND,
      values: { value: 'accentLight' },
      items: []
    },
    {
      id: '3',
      type: LAYOUT_LIST,
      values: {
        align: 'center'
      },
      items: [
        {
          id: '4',
          type: TEXT,
          values: {
            variant: 'heading1',
            value: 'Unknown template'
          },
          items: []
        },
        {
          id: '5',
          type: TEXT,
          values: {
            value:
              'The template for this sequence has not yet been implemented...'
          },
          items: []
        }
      ]
    }
  ]
};

export const translate: Translator = sequence => {
  switch (sequence.templateName) {
    case 'Images1':
      return Images1(sequence);
    case 'Images2':
      return Images2(sequence);
    case 'Images2BackgroundColor':
      return Images2BackgroundColor(sequence);
    case 'Images3':
      return Images3(sequence);
    case 'Images3_text':
      return Images3(sequence);
    case 'Images6':
      return Images6(sequence);
    case 'Images7':
      return Images7(sequence);
    case 'Images9':
      return Images9(sequence);
    case 'Multimedia1':
      return Multimedia1(sequence);
    case 'Multimedia2':
      return Multimedia2(sequence);
    case 'Multimedia4':
      return Multimedia4(sequence);
    case 'Multimedia4_Quiz':
      return Multimedia4_Quiz(sequence);
    case 'Multimedia8':
      return Multimedia8(sequence);
    case 'List1':
      return List1(sequence);
    case 'List2':
      return List2(sequence);
    case 'List3':
    case 'List4':
      return List3(sequence);
    case 'Statement1':
    case 'Statement2':
    case 'Definition2':
      return Statement2(sequence);
    case 'Statement3':
      return Statement3(sequence);
    case 'Statement5':
      return Statement5(sequence);
    case 'Statement6':
      return Statement6(sequence);
    case 'Cards1':
      return Cards1(sequence);
    case 'Cards2':
      return Cards2(sequence);
    case 'Cards3':
    case 'Quiz21':
      return Cards3(sequence);
    case 'Cards4':
      return Cards4(sequence);
    case 'Cards5':
      return Cards5(sequence);
    case 'Cards6':
      return Cards6(sequence);
    case 'Cards7':
    case 'Quiz20_v3':
      // both templates really are the same...
      return Cards7(sequence);
    case 'Cards8':
      return Cards8(sequence);
    case 'Cards10':
      return Cards10(sequence);
    case 'Quiz20':
      return Cards7(sequence);
    case 'Quiz20v2':
      return Cards61(sequence);
    case 'Quiz30':
      return Quiz30(sequence);
    case 'SocialMedia1':
      return SocialMedia1(sequence);
    case 'SocialMedia2':
      return SocialMedia2(sequence);
    case 'SocialMedia3':
      return SocialMedia3(sequence);
    case 'SocialMedia4':
      return SocialMedia4(sequence);
    case 'SocialMedia5':
      return SocialMedia5(sequence);
    case 'SocialMedia5_iPad':
      return SocialMedia5iPad(sequence);
    case 'SocialMedia6':
    case 'SocialMedia7':
      return SocialMedia6(sequence);
    case 'SocialMedia6_iPad':
      return SocialMedia6iPad(sequence);
    case 'SocialMedia8':
      return SocialMedia8(sequence);
    case 'SocialMedia9':
      return SocialMedia9(sequence);
    case 'SocialMedia10':
      return SocialMedia10(sequence);
    case 'SocialMedia12':
      return SocialMedia12(sequence);
    case 'SocialMedia13':
      return SocialMedia13(sequence);
    case 'SocialMedia14':
      return SocialMedia14(sequence);
    case 'SocialMedia_PushNotifications':
      return SocialMediaPushNotifications(sequence);
    case 'Quiz2':
      return Quiz2(sequence);
    case 'Quiz3':
      return Quiz3(sequence);
    case 'Quiz4':
      return Quiz4(sequence);
    case 'Quiz5':
      return Quiz5(sequence);
    case 'Quiz8':
      return Quiz8(sequence);
    case 'Quiz9':
      return Quiz9(sequence);
    case 'Quiz10':
      return Quiz10(sequence);
    case 'Quiz11':
      return Quiz11(sequence);
    case 'Quiz12':
      return Quiz12(sequence);
    case 'Quiz13':
      return Quiz13(sequence);
    case 'Quiz_steps':
      return Quiz13Steps(sequence);
    case 'Quiz14':
      return Quiz14(sequence);
    case 'Quote3':
      return Quote3(sequence);
    case 'Quote5':
      return Quote5(sequence);
    case 'Quote7':
      return Quote7(sequence);
    case 'Interactive1':
      return Interactive1(sequence);
    case 'Interactive2':
      return Interactive2(sequence);
    case 'Interactive3':
      return Interactive3(sequence);
    case 'Interactive30':
      return Interactive30(sequence);
    case 'Interactive31':
      return Interactive31(sequence);
    case 'Quiz_FIB_doors':
      return Interactive32(sequence);
    case 'Quiz_Insta':
      return QuizInsta(sequence);
    case 'Quiz_Insta_Survey':
      return QuizInstaSurvey(sequence);
    case 'Quiz_Phone_Notification':
      return QuizPhoneNotification(sequence);
    case 'Interactive23':
      return Interactive23(sequence);
    case 'Interactive4':
      return Interactive4(sequence);
    case 'Interactive7':
      return Interactive7(sequence);
    case 'Interactive8':
      return Interactive8(sequence);
    case 'Interactive9':
      return Interactive9(sequence);
    case 'Interactive11':
      return Interactive11(sequence);
    case 'Interactive12':
      return Interactive12(sequence);
    case 'Interactive13':
      return Interactive13(sequence);
    case 'Interactive14':
      return Interactive14(sequence);
    case 'Interactive_PDF':
      return InteractivePDF(sequence);
    case 'Text2':
      return Text2(sequence);
    case 'Text4':
      return Text4(sequence);
    case 'Text5':
      return Text5(sequence);
    case 'Chart_pie':
      return ChartPie(sequence);
    case 'Chart_doughnut':
      return ChartDoughnut(sequence);
    case 'Chart_polar':
      return ChartPolar(sequence);
    case 'Chart_bar':
      return ChartBar(sequence);
    case 'Chart_line':
      return ChartLine(sequence);
    case 'Drag_n_drop':
      return DragNDrop(sequence);
    case 'ChatBot':
      return Simulation(sequence);
    default:
      return UnknownTemplate;
  }
};
